'use client'

import { useUser } from '@auth0/nextjs-auth0'
import { Switch } from '@teqplay/ui'
import Link from 'next/link'
import { useState } from 'react'

import ModalPortReporter from '@/app/components/Modals/ModalPortReporter'

type TProps = {
  toggled: boolean
  vesselImo: string
}

function NotificationBellPublic(props: TProps) {
  const { user } = useUser()
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  if (user) {
    return <Switch checked={props.toggled} />
  }

  return (
    <>
      <Switch onCheckedChange={() => setIsModalOpen(true)} checked={props.toggled} />
      <ModalPortReporter isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  )
}

export default NotificationBellPublic
